import { ChangeEventHandler, RefCallback, useCallback, useEffect, useState } from 'react';

export function useFieldAutoHeight<T extends HTMLElement>(
  onChange: ChangeEventHandler<T> | undefined,
  value: string
): [RefCallback<T>, ChangeEventHandler<T>] {
  const [node, setNode] = useState<T | null>(null);

  const ref = useCallback((refNode: T) => {
    setNode(refNode);
  }, []);

  const handleChange: ChangeEventHandler<T> = useCallback(
    (e) => {
      if (node) {
        node.style.height = 'auto';
        node.style.height = `${node.scrollHeight}px`;
      }

      if (onChange) {
        onChange(e);
      }
    },
    [node, onChange]
  );

  useEffect(() => {
    if (node) {
      node.style.height = 'auto';
      node.style.height = `${node.scrollHeight}px`;
    }
  }, [node, value]);

  useEffect(() => {
    if (node) {
      node.style.overflowY = 'hidden';
      node.style.height = `${node.scrollHeight}px`;
    }

    return () => {
      if (node) {
        node.style.overflowY = '';
        node.style.height = '';
      }
    };
  }, [node]);

  return [ref, handleChange];
}
